import { z } from "zod";
export const ExporterWorkspaceMembershipRole = z.enum([
    "Owner",
    "OwnerArchived",
    "User",
]);
